import React from "react";
import "./SideBar/style.scss";

export default function DialogBox({
  open,
  setOpen,
  handleAgree,
  title = "",
  contentText = "",
}) {
  if (!open) return null;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="dialogBox_wrapper">
      <div className="dialogBox">
        <h2 className="titleBox">{title}</h2>
        <p className="contentBox">{contentText}</p>
        <div className="dialogActions">
          <button className="dialogButton ok" onClick={handleAgree}>
            Ok
          </button>
          <button className="dialogButton cancel" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
